import { Environment } from 'config/environment';

export interface SentryConfig {
  dsn: string;
  environment: string;
  tracesSampleRate: number;
  replaysSessionSampleRate: number;
  replaysOnErrorSampleRate: number;
  enableLogs: boolean;
  debug?: boolean;
  sendDefaultPii?: boolean;
}

export const environmentConfigs: Record<Environment, SentryConfig> = {
  development: {
    dsn: 'https://6492500306a3f97d4e90a1f15087ab0b@sentry.eis24.me/31',
    environment: 'development',
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: true,
    debug: false, //консоль
    sendDefaultPii: true,
  },
  test: {
    dsn: 'https://97c9dc16fec23c704089d7833f044d52@sentry.eis24.me/31',
    environment: 'test',
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: false,
    debug: false,
    sendDefaultPii: false,
  },
  production: {
    dsn: 'https://9a0c4240408c26cfacbd3971fb473aab@sentry.eis24.me/31',
    environment: 'production',
    tracesSampleRate: 0.01,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    enableLogs: false,
    debug: false,
    sendDefaultPii: false,
  },
};
